import React from "react";
import Header from "../../components/HeaderNavy";
import Footer from "../../components/FooterNavy";
import ContactSection from "../../components/ContactSection";
import ComingSoonPromoters from "../../components/Promoters/ComingSoonPromoters";

function Home() {
  return (
    <>
      <Header />
      <ComingSoonPromoters />
      <ContactSection />
      <Footer /> 
    </>
  );
}

export default Home;
